export default __webpack_public_path__ + "static/7-3760f9baece88148d6dd64bdb853dc8e.webp";